import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { ApiReportTimelapseGetRequest, ReportApi } from '../../../api/generated/Api'
import { handleFileDownload, HttpContentDispositionHeader } from '../../../utils/HandleFileDownload'
import { GetApiConfig } from '../../auth/services/authService'

export const useTimelapseGetApi = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)
  const { enqueueSnackbar } = useSnackbar()

  const download = useCallback(
    (request: ApiReportTimelapseGetRequest) => {
      if (isLoading) return

      setError(undefined)
      setIsLoading(true)

      new ReportApi(GetApiConfig())
        .apiReportTimelapseGet(request, HttpContentDispositionHeader)
        .then(handleFileDownload)
        .catch((e) => {
          setError(e)
          enqueueSnackbar('Failed to download timelapse', { variant: 'error' })
        })
        .then((blob) => {
          setIsLoading(false)
        })
    },
    [isLoading, enqueueSnackbar],
  )

  return { isLoading, error, download }
}
